import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/new-design/images/upload-icon.png'


const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "ledger-title" }, "Upload Tenant Ledger", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop file here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to upload")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " PDF files with a size less than 5mb ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["justify-content-start align-items-start ledger-container", { current: _ctx.isCurrent }]),
    "data-kt-stepper-element": "content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          ref: "uploader",
          drag: "",
          "auto-upload": false,
          accept: ".pdf",
          "list-type": "pdf",
          "on-change": _ctx.onChange,
          "on-remove": _ctx.handleRemove,
          limit: 1
        }, {
          tip: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["on-change", "on-remove"])
      ])
    ])
  ], 2))
}